import type { IconType } from 'react-icons'
import { LuHandHeart, LuNetwork, LuUsers } from 'react-icons/lu'

import {
  CommunitiesRoutes,
  NetworksRoutes,
  PoolingRoutes,
} from '@/routes/_hooks/routes.enum'

export type ProfileKey = 'member' | 'animator' | 'federator'

export interface ProfileConfig {
  key: ProfileKey
  colorPalette: 'brand' | 'blue' | 'pink'
  /** react-icons component rendered inside the selectable card / intro hero. */
  icon: IconType
  /** Number of steps in the mini-onboarding shown on the intro screen. */
  stepCount: number
  /** Route the post-activation exit navigates to (member landing, fallbacks). */
  destination: string
  /** Base i18n key for this profile's copy (cardTitle, features, cta, ...). */
  i18nKey: string
  /**
   * Optional hero illustration (public path). Left empty for now — the cards and
   * intro screens fall back to a brand gradient + icon. Wire real assets here.
   */
  image?: string
}

export const PROFILES: ProfileConfig[] = [
  {
    key: 'member',
    colorPalette: 'brand',
    icon: LuHandHeart,
    // Mini-flow: add first material + discover communities to join.
    stepCount: 2,
    destination: PoolingRoutes.Search,
    i18nKey: 'register.wizard.profiles.member',
  },
  {
    key: 'animator',
    colorPalette: 'blue',
    icon: LuUsers,
    stepCount: 2,
    destination: CommunitiesRoutes.New,
    i18nKey: 'register.wizard.profiles.animator',
  },
  {
    key: 'federator',
    colorPalette: 'pink',
    icon: LuNetwork,
    stepCount: 2,
    destination: NetworksRoutes.New,
    i18nKey: 'register.wizard.profiles.federator',
  },
]
